
















































import { computed, defineComponent, ref } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { getCost } from "@/lib/moneyHelpers";
import { PurchaseInfo } from "@/payments/types";
import { ContentFeedPurchaseEvent } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import PaymentConfirmation from "@/components/PaymentConfirmation";
import UserSubscribeModal from "@/components/UserSubscribeModal";

export default defineComponent({
  name: "UnlockFeedView",
  components: { PaymentConfirmation, UserSubscribeModal, PageTitle, BaseButton, ModalView, BaseConfirm, FormatMoney },
  props: {
    selectedFeed: { type: Object as () => ContentFeed, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    purchaseProcessing: { type: Boolean, required: true },
    paymentInfo: { type: Object as () => PurchaseInfo, required: true },
    typeOfPurchase: { type: Object as () => Omit<ContentFeedPurchaseEvent, "feed"> },
  },
  setup(props, { emit }) {
    const openPaymentConfirm = ref(false);
    const isOnlyPrice = computed(() => {
      return (
        (!!props.typeOfPurchase && props.typeOfPurchase.oneTimePurchase) ||
        (props.selectedFeed.subscriptionLevelId === "0" && props.selectedFeed.pricePackageId !== "0")
      );
    });
    const oneTimeCost = computed(() => {
      if (props.selectedFeed.pricePackageId === "0") return 0;

      const paymentPackage = props.paymentPackages.find(item => item.id === props.selectedFeed.pricePackageId);
      if (!paymentPackage) return 0;

      return getCost(paymentPackage);
    });
    const isOnlySubscription = computed(() => !!props.typeOfPurchase && props.typeOfPurchase.subscription);

    const showUnlockButton = computed(() => !isOnlySubscription.value && !!oneTimeCost.value);
    const showSubscriptionList = computed(() => !isOnlyPrice.value || isOnlySubscription.value);

    const showPaymentConfirmation = computed(() => isOnlyPrice.value || openPaymentConfirm.value);

    const onClose = () => {
      if (props.purchaseProcessing) return;
      if (isOnlyPrice.value) {
        emit("close");
      }
      openPaymentConfirm.value = false;
    };
    return {
      isOnlyPrice,
      oneTimeCost,
      showPaymentConfirmation,
      openPaymentConfirm,
      showUnlockButton,
      showSubscriptionList,
      onClose,
    };
  },
});
